import { tracker } from 'app-components/utils/core';

export type TopBarNavSection =
  | 'topbar-settings'
  | 'topbar-help'
  | 'topbar-profile'
  | 'topbar-notifications'
  | 'topbar-ai';

type TrackTopBarNavMenuClickProps = {
  menuItem: string;
  section: TopBarNavSection;
  value?: string;
};

export function trackTopBarNavMenuClick({ menuItem, section, value }: TrackTopBarNavMenuClickProps): void {
  tracker.track(tracker.events.navMenuClick, {
    menuItem,
    section,
    menu_path: `${section}:${menuItem}`,
    ...(value != null ? { value } : {}),
  });
}
